const projects = [
    {
      category: "Full-Stack Web Applications",
      projects: [
         {
        title: "Portfolio Website",
        projectSlug: "portfolio-website",
        description: "A full-stack developer portfolio that showcases projects, resume, blogs, and professional experience. Includes a protected admin dashboard, Markdown-supported blog platform with likes and commenting, and secure resume upload with PDF preview. Built with JWT authentication, Zustand-powered state management, and responsive UI using Tailwind CSS.",
        stack: ["ReactJS", "NodeJS", "Express", "MongoDB", "TailwindCSS", "Zustand", "JWT"],
        liveLink: "https://chahat-portfolio.vercel.app/"
      },
      {
        title: "SafariCraft: Immersive E-Commerce & Sidekick AI Integration",
        projectSlug: "safari-immersive-shopify-experience",
        description: "Safari-themed premium Shopify storefront featuring shoppable product hotspots, visual comparison sliders, and dynamic bento grids. Powered by an admin Preact dashboard database mapping Shopify Metaobjects and registering custom Shopify Sidekick AI tools alongside React checkout extensions.",
        stack: ["ReactJS", "NodeJS", "TailwindCSS", "JavaScript", "Docker", "GitHub"],
        liveLink: "https://www.safari-lifestyle-demo.com"
      },
        {
          title: "StockPilot: Intelligent Inventory & Sales Management",
          projectSlug: "stockpilot-intelligent-inventory-sales-management",
          description: "AI-powered platform to manage inventory, customers, sales, purchases, and promotions with real-time dashboards, Genkit-powered recommendations, and Firebase Auth.",
          stack: ["NextJS", "ReactJS", "TypeScript", "MongoDB", "Firebase Auth", "Cloudinary", "TailwindCSS", "ShadCN", "Firebase"]
        },
        {
          title: "URL Shortener",
          projectSlug: "url-shortener",
          description: "Built a web app to shorten URLs with input validation, click tracking, and secure redirection.",
          stack: ["JavaScript", "NodeJS", "Express", "MongoDB", "Ejs", "TailwindCSS"],
          liveLink: "https://url-shortner-c7ck.onrender.com/"
        },
    {
          title: "Chat Messaging App",
          projectSlug: "chat-messaging-app",
          description: "Real-time messaging web app with channel-based chat and responsive design using StreamChat API.",
          stack: ["ReactJS", "StreamChat API", "JavaScript", "Zustand"]
        }
      ]
    },
    {
      category: "AI & Automation",
      projects: [
        {
          title: "Home Automation System using AI and ML",
          projectSlug: "home-automation-system",
          description: "Smart home solution with face recognition door lock and smart device control. Real-time image processing with OpenCV and data sync via Firebase.",
          stack: ["Flask", "OpenCV", "Firebase", "Back4App", "REST API"],
          liveLink: "https://github.com/Chahatj23/Home-Automation-System-Android-App"
        },
        {
          title: "Amazon Web Scraper",
          projectSlug: "amazon-web-scraper",
          description: "Python script to scrape product and homepage data from Amazon. Extendable for price alerts and analysis.",
          stack: ["Python", "BeautifulSoup", "Requests"]
        },
        {
          title: "Unified AI Agent (Email, Chatbot & Scheduler)",
          projectSlug: "unified-ai-agent",
          description: "Built an AI-powered lead management system that automates replies, captures lead data, and books appointments via chatbot. Integrates OpenAI with Node.js, HubSpot, Landbot, Calendly, n8n, and Zapier for 100% process automation.",
          stack: ["NodeJS", "OpenAI API", "n8n", "Zapier", "HubSpot", "Landbot", "Calendly"]
        },
        {
          title: "Personalized Career Mentor AI",
          projectSlug: "personalized-career-mentor-ai",
          description: "Capstone project submitted to Google x Kaggle using Gemini API. Recommends learning paths using grounding, few-shot prompting, and doc understanding.",
          stack: ["Python", "LangChain", "Gemini API", "Google Search API", "YouTube API"],
          liveLink: "https://www.kaggle.com/code/chahatj23/personalized-ai-mentor"
        }
      ]
    },
    {
      category: "Mobile & Android Development",
      projects: [
        {
          title: "Musify – Music Player App",
          projectSlug: "musify-music-player-app",
          description: "Music streaming Android app with Firebase login and offline playback using SQLite.",
          stack: ["Java", "Firebase", "SQLite", "XML"]
        },
        {
          title: "Interest Calculator App",
          projectSlug: "interest-calculator-app",
          description: "Android app for calculating interest with support for 'Till Today' logic and monthly/yearly compounding.",
          stack: ["Kotlin", "Android Studio"]
        }
      ]
    },
    
    {
      category: "System / CLI Tools",
      projects: [
        {
          title: "Student Record Management System",
          projectSlug: "student-record-management-system",
          description: "CLI app built in C++ for student data management using CRUD operations and core DSA concepts.",
          stack: ["C++", "OOP", "Data Structures"]
        }
      ]
    },
    {
      category: "CRM / Enterprise Tools",
      projects: [
        {
          title: "Salesforce & HubSpot CRM Enhancements",
          projectSlug: "salesforce-hubspot-crm-enhancements",
          description: "Built custom health scores, automated workflows, and retention tracking for SaaS companies using Salesforce (LWC, Apex) and HubSpot Workflows.",
          stack: ["Salesforce", "HubSpot", "Flow", "Apex", "CRM Tools"]
        }
      ]
    },
  ];


  export default projects;